import { Skeleton } from '@mui/material';
import Menu from '@mui/material/Menu';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { PiForkKnifeLight, PiShoppingBag, PiTruckLight } from 'react-icons/pi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Plus from 'src/assets/images/Plus.svg';
import filter from 'src/assets/images/SlidersHorizontal.svg';
import { Modal } from 'src/components';
import Button from 'src/components/button';
import Tables from 'src/components/tables';
import TextField from 'src/components/text-field';
import Tickets from 'src/components/tickets';
import {
  clearCurrentOrder,
  fetchDeliveryCharge,
  fetchTaxes,
} from 'src/redux/action/currentOrder.action';
import {
  fetchOrderTypesSuccess,
  fetchSales,
} from 'src/redux/action/sales.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { SalesFloor } from 'src/types/model';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';
import ting from '../../../assets/ting.mp3';
import './a.css';
import { ClockCounterClockwiseIcon, TicketIcon } from '@phosphor-icons/react';

const FORM_VALIDATION = Yup.object().shape({
  amountCashAdd: Yup.number()
    .required('Amount is required')
    .min(0, 'Amount must be greater than or equal to 0'),
  amountCashRemove: Yup.number()
    .required('Amount is required')
    .min(0, 'Amount must be greater than or equal to 0'),
});

const DineIn: React.FC = () => {
  const [currentOrderType, setCurrentOrderType] = useState<string>('dine_in');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElCash, setAnchorElCash] = React.useState<null | HTMLElement>(
    null
  );
  const openCash = Boolean(anchorElCash);
  const handleClickCash = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorElCash(event.currentTarget);
  };
  const handleCloseCash = () => {
    setAnchorElCash(null);
  };

  const dispatch = useDispatch();

  const { salesData, loading, orderType } = useSelector(
    ({ salesData }: RootState) => salesData
  );
  const { floors, orders } = salesData;
  const navigate = useNavigate();
  const [filterFloors, setFilterFloors] = useState('All');
  const [showCashAddModal, setShowCashAddModal] = useState<boolean>(false);
  const [showCashRemoveModal, setShowCashRemoveModal] =
    useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchSales() as any);
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    const fetchOrderType = async () => {
      try {
        const res = await Service.get('/businesses/orderTypes');
        dispatch(fetchOrderTypesSuccess(res.data));
      } catch (err: any) {}
    };
    fetchOrderType();
  }, []);

  useEffect(() => {
    dispatch(fetchSales() as any);
    dispatch(clearCurrentOrder());
    dispatch(fetchTaxes() as any);
    dispatch(fetchDeliveryCharge() as any);
    // dispatch(fetchUsers() as any);
  }, []);

  const tables = useMemo(() => {
    if (filterFloors.trim() !== '') {
      const matchingFloor = floors?.find(
        (floor: SalesFloor) =>
          floor.name.toLowerCase() === filterFloors.toLowerCase()
      );

      if (matchingFloor) {
        return matchingFloor.defaultTables;
      }
    }

    // If no matching floor is found or filterTable is empty, return items from all defaultTables
    return floors?.flatMap((floor: SalesFloor) => floor.defaultTables);
  }, [filterFloors, floors]);

  // to close menu when clicked outside
  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as Node)) {
        handleClose();
      }
      if (anchorElCash && !anchorElCash.contains(event.target as Node)) {
        handleCloseCash();
      }
    };

    window.addEventListener('click', handleOutsideClick);

    return () => {
      window.removeEventListener('click', handleOutsideClick);
    };
  }, [anchorEl, anchorElCash]);

  const intValues = {
    amountCashAdd: 0,
    amountCashRemove: 0,
    noteCashAdd: '',
    noteCashRemove: '',
  };

  const handleSubmitCashAdd = async (val: any) => {
    const payload = {
      amount: val.amountCashAdd,
      note: val.noteCashAdd,
    };

    handleModal();
    try {
      await Service.post('/cashes/add', payload);
      toastAlert('success', `Added cash successfully`);
    } catch (err: any) {
      toastAlert('error', err.message);
    }
  };

  const handleSubmitCashRemove = async (val: any) => {
    const payload = {
      amount: val.amountCashRemove,
      note: val.noteCashRemove,
    };

    handleModal();
    try {
      await Service.post('/cashes/remove', payload);
      toastAlert('success', `Removed cash successfully`);
    } catch (err: any) {
      toastAlert('error', err.message);
    }
  };

  const handleModal = () => {
    setShowCashAddModal(false);
    setShowCashRemoveModal(false);
  };

  useEffect(() => {
    const hasNewOrder = tables.find((x: any) => x.hasNewOrder);
    if (!hasNewOrder) return;

    let playCount = 0;
    const maxPlays = 3;

    const intervalId = setInterval(() => {
      if (playCount >= maxPlays) {
        clearInterval(intervalId);
        return;
      }
      var audio = new Audio(ting);
      audio.play();
      playCount++;
    }, 3000);

    return () => clearInterval(intervalId);
  }, [tables]);

  return (
    <>
      <div className="w-full h-[calc(100vh-75px)] text-black flex flex-row justify-between gap-4">
        <div className="w-full h-full flex flex-col">
          <div className="flex flex-col xl:flex-row gap-3 xl:gap-0 justify-between">
            <div className="flex h-10 gap-3 w-fit items-center ">
              {orderType?.dine_in && (
                <div
                  className={`flex cursor-pointer items-center justify-center w-auto h-8 px-3  text-[14px] leading-[21px] font-normal py-2 gap-1.5 rounded-full border border-gray-300 bg-white hover:text-[#4062FF]  hover:border-[#4062FF] ${
                    currentOrderType === 'dine_in'
                      ? 'text-[#4062FF] font-semibold border-[#4062FF]'
                      : 'text-[#949CC0] font-normal border-[#949CC0]'
                  }`}
                  onClick={() => {
                    setCurrentOrderType('dine_in');
                  }}
                >
                  <PiForkKnifeLight />
                  Dine In
                </div>
              )}
              {orderType?.takeaway && (
                <div
                  className={`flex cursor-pointer items-center justify-center w-auto h-8 px-3  text-[14px] leading-[21px] font-normal py-2 gap-1.5 rounded-full border border-gray-300 bg-white hover:text-[#4062FF]  hover:border-[#4062FF] ${
                    currentOrderType === 'takeaway'
                      ? 'text-[#4062FF] font-semibold border-[#4062FF]'
                      : 'text-[#949CC0] font-normal border-[#949CC0]'
                  }`}
                  onClick={() => {
                    // navigate('/table', {
                    //   state: { table: null, type: 'takeaway' },
                    // });
                    setCurrentOrderType('takeaway');
                  }}
                >
                  <PiShoppingBag />
                  Takeaway
                </div>
              )}
              {orderType?.delivery && (
                <div
                  className={`flex cursor-pointer items-center justify-center w-auto h-8 px-3  text-[14px] leading-[21px] font-normal py-2 gap-1.5 rounded-full border border-gray-300 bg-white hover:text-[#4062FF]  hover:border-[#4062FF] ${
                    currentOrderType === 'delivery'
                      ? 'text-[#4062FF] font-semibold border-[#4062FF]'
                      : 'text-[#949CC0] font-normal border-[#949CC0]'
                  }`}
                  onClick={() => {
                    // navigate('/table', {
                    //   state: { table: null, type: 'delivery' },
                    // });
                    setCurrentOrderType('delivery');
                  }}
                >
                  <PiTruckLight />
                  Delivery
                </div>
              )}

              {Object.keys(orderType).length === 0 && (
                <div className="flex items-center gap-3">
                  <Skeleton
                    animation="wave"
                    width={115}
                    height={33}
                    variant="rounded"
                    sx={{ borderRadius: '50px' }}
                  />{' '}
                  <Skeleton
                    animation="wave"
                    width={115}
                    height={33}
                    variant="rounded"
                    sx={{ borderRadius: '50px' }}
                  />{' '}
                  <Skeleton
                    animation="wave"
                    width={115}
                    height={33}
                    variant="rounded"
                    sx={{ borderRadius: '50px' }}
                  />
                </div>
              )}

              {/* {orderType?.online_order && (
                  <div
                    className={`flex cursor-pointer items-center justify-center w-auto h-8 px-3  text-[14px] leading-[21px] font-normal py-2 gap-1.5 rounded-full border border-gray-300 bg-white hover:text-[#4062FF]  hover:border-[#4062FF] ${
                      currentOrderType === 'online_order'
                        ? 'text-[#4062FF] font-semibold border-[#4062FF]'
                        : 'text-[#949CC0] font-normal border-[#949CC0]'
                    }`}
                    onClick={() => {
                      setCurrentOrderType('/online_order');
                    }}
                  >
                    <PiCursor />
                    Online Order
                  </div>
                )} */}
            </div>
            <div className="flex gap-6">
              <button
                type="button"
                onClick={() => {
                  navigate('/open-tickets');
                }}
                className="flex gap-2 items-center cursor-pointer w-auto h-10  border border-[#CACFE3] hover:border-[#2B2B2B] rounded-xl p-2"
              >
                <TicketIcon size={25}  />
                <span className='text-xs xl:text-base'>Open tickets</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  navigate('/closed-tickets');
                }}
                className="flex gap-2 items-center cursor-pointer w-auto h-10  border border-[#CACFE3] hover:border-[#2B2B2B] rounded-xl p-2"
              >
                <ClockCounterClockwiseIcon size={25} />
                <span className='text-xs xl:text-base'>Closed tickets</span>
              </button>

              {currentOrderType === 'dine_in' && (
                <div
                  className="p-2 gap-2 h-10 rounded-xl flex items-center justify-center border border-[#CACFE3] cursor-pointer hover:border-[#2B2B2B]"
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <img src={filter} alt="filter" />
                  <span className='text-xs xl:text-base'>Filter</span>
                </div>
              )}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                  style: {
                    boxShadow: 'none',
                    width: 'max-content',
                    marginTop: '10px',
                    border: '1px solid #F1F0F6',
                    height: 'fit-content',
                    transform: 'translate(-20%,0)',
                    backgroundColor: '#FFFFFF',
                    padding: '12px 24px',
                    overflow: 'hidden',
                  },
                }}
              >
                <div
                  className={`font-Outfit font-normal text-[16px] leading-6  hover:text-[#4062FF] cursor-pointer ${
                    filterFloors === 'All' ? 'text-[#4062FF]' : 'text-[#2B2B2B]'
                  }`}
                  onClick={() => {
                    setFilterFloors('All');
                  }}
                >
                  All
                </div>
                {floors?.map((fl: SalesFloor, ind: number) => {
                  return (
                    <div
                      key={ind}
                      className={`font-Outfit font-normal text-[16px] mt-2 leading-6 text-[#2B2B2B] cursor-pointer hover:text-[#4062FF] ${
                        filterFloors === fl.name
                          ? 'text-[#4062FF]'
                          : 'text-[#2B2B2B]'
                      }`}
                      onClick={() => {
                        setFilterFloors(fl.name);
                      }}
                    >
                      {fl.name}
                    </div>
                  );
                })}
              </Menu>
            </div>
          </div>

          {currentOrderType === 'dine_in' && (
            <Tables
              loading={tables.length > 0 ? false : loading}
              tables={tables}
              // orders={orders}
            />
          )}
          {currentOrderType === 'takeaway' && (
            <div className="flex flex-wrap gap-[22px] mt-4 ">
              {orders
                .filter((order: any) => order.type === 'takeaway')
                .map((item: any) => (
                  <div
                    className="w-[120px] h-[120px] rounded-xl bg-[#F1F0F6] flex justify-center items-center flex-col font-Sarabun font-semibold text-[32px] cursor-pointer leading-[41px]"
                    key={item.id}
                    onClick={() => {
                      navigate('/table', {
                        state: {
                          table: null,
                          type: item.type,
                          orderId: item.id,
                        },
                      });
                    }}
                  >
                    <div>#ORD</div>
                    <div className="font-medium text-2xl">
                      {item.referenceNumber.split('-')[1]}
                    </div>
                  </div>
                ))}

              <div
                className="w-[120px] h-[120px] flex justify-center items-center cursor-pointer border-[2px] rounded-xl border-dashed border-[#4062FF]"
                onClick={() => {
                  navigate('/table', {
                    state: { table: null, type: 'takeaway' },
                  });
                }}
              >
                <img src={Plus} alt="plus" />
              </div>
            </div>
          )}
          {currentOrderType === 'delivery' && (
            <div className="flex flex-wrap gap-[22px] mt-4 ">
              {orders
                .filter((order: any) => order.type === 'delivery')
                .map((item: any) => (
                  <div
                    className="w-[120px] h-[120px] rounded-xl bg-[#F1F0F6] flex justify-center items-center flex-col font-Sarabun font-semibold text-[32px] cursor-pointer"
                    key={item.id}
                    onClick={() => {
                      navigate('/table', {
                        state: {
                          table: null,
                          type: item.type,
                          orderId: item.id,
                        },
                      });
                    }}
                  >
                    <div>#ORD</div>
                    <div className="font-medium text-2xl">
                      {item.referenceNumber.split('-')[1]}
                    </div>
                  </div>
                ))}
              <div
                className="w-[120px] h-[120px] flex justify-center items-center cursor-pointer border-[2px] rounded-xl border-dashed border-[#4062FF]"
                onClick={() => {
                  navigate('/table', {
                    state: { table: null, type: 'delivery' },
                  });
                }}
              >
                <img src={Plus} alt="plus" />
              </div>
            </div>
          )}
          {showCashAddModal && (
            <Modal title="Add Cash" onClick={handleModal} className="w-[388px]">
              <div className="mt-4">
                <Formik
                  initialValues={intValues}
                  validateOnMount
                  validationSchema={FORM_VALIDATION}
                  onSubmit={handleSubmitCashAdd}
                >
                  {({ isSubmitting, isValid }) => (
                    <Form className="mt-5">
                      <TextField
                        label="Amount"
                        name="amountCashAdd"
                        type="text"
                        labelClassName="text-sm  text-[#2B2B2B] font-Outfit"
                      />

                      <div className="mt-1 flex flex-col">
                        <label
                          htmlFor="noteCashAdd"
                          className="text-sm  text-[#2B2B2B] font-Outfit "
                        >
                          Note
                        </label>
                        <Field
                          as="textarea"
                          className="border-[1px] border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none"
                          rows={4}
                          cols={42}
                          name="noteCashAdd"
                        />
                      </div>

                      <div className="flex flex-row justify-end gap-6 items-center w-full mt-6">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={handleModal}
                        >
                          Cancel
                        </div>
                        <Button
                          text={showCashAddModal ? 'Add Cash' : ' Remove Cash'}
                          variant="primary"
                          isSubmitting={isSubmitting}
                          isValid={isValid}
                          type="submit"
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Modal>
          )}
          {showCashRemoveModal && (
            <Modal
              title="Remove Cash"
              onClick={handleModal}
              className="w-[388px]"
            >
              <div className=" mt-4">
                <Formik
                  initialValues={intValues}
                  validateOnMount
                  validationSchema={FORM_VALIDATION}
                  onSubmit={handleSubmitCashRemove}
                >
                  {({ isSubmitting, isValid }) => (
                    <Form className="mt-5">
                      <TextField
                        label="Amount"
                        name="amountCashRemove"
                        type="text"
                        className="w-[340px]"
                        labelClassName="text-sm  text-[#2B2B2B] font-Outfit"
                      />

                      <div className="mt-1 flex flex-col  ">
                        <label
                          htmlFor="noteCashRemove"
                          className="text-sm  text-[#2B2B2B] font-Outfit"
                        >
                          Note
                        </label>
                        <Field
                          as="textarea"
                          className="w-[340px] border-[1px] border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none"
                          rows={4}
                          cols={42}
                          name="noteCashRemove"
                        />
                      </div>

                      <div className="flex flex-row justify-end gap-6 items-center w-full mt-6">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={handleModal}
                        >
                          Cancel
                        </div>
                        <Button
                          text={showCashAddModal ? 'Add Cash' : ' Remove Cash'}
                          variant="primary"
                          isSubmitting={isSubmitting}
                          isValid={isValid}
                          type="submit"
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Modal>
          )}
        </div>

        <Tickets orders={orders} type="dine_in" />
      </div>
    </>
  );
};

export default DineIn;
